import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'

import Box from 'components/box'
import ValueLabel from 'components/value-label'
import EventListButton from 'components/event-list-button'

import styles from './event-draft-list-item.css'

export const EventDraftListItem = ({
  name,
  onCardClick,
  onDeleteClick,
  onLinkClick,
  url,
}) => (
  <div styleName="event-draft-list-item">
    <Box interactive>
      <div styleName="wrapper" onClick={onCardClick}>
        <Relayout gutter={false} valign="middle">
          <RelayoutItem sm="12">
            <div styleName="title">
              <ValueLabel value={name} />
            </div>
          </RelayoutItem>
          <RelayoutItem sm="12">
            <div styleName="actions">
              <a styleName="action-continue" href={url} onClick={onLinkClick}>
                <EventListButton label="Continue editing" type="primary" />
              </a>
              <a styleName="action-remove" onClick={onDeleteClick}>
                <EventListButton label="Remove" type="secondary" />
              </a>
            </div>
          </RelayoutItem>
        </Relayout>
      </div>
    </Box>
  </div>
)

EventDraftListItem.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  onCardClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onLinkClick: PropTypes.func,
}

export default CSSModules(EventDraftListItem, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/event-draft-list-item/event-draft-list-item.js
 **/